<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <v-card
      max-width="344"
      :elevation="hover && !disabled ? 10 : elevation"
      class="mx-auto"
      :disabled="disabled"
      hover
      :ripple="!$slots.actions"
      @click.stop="$emit('click')"
    >
      <v-list-item
        v-if="$slots.heading"
        :class="classes"
        :dark="primary"
      >
        <slot name="heading"/>
      </v-list-item>

      <template v-if="$slots.content">
        <slot name="content"/>
      </template>

      <v-card-text v-if="detail" v-html="detail"/>

      <v-card-actions v-if="$slots.actions">
        <slot name="actions"/>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>

export default {

  props: {
    // size
    // TODO: small, largeによって大きさを変更できるようにする
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false,
    },
    // color
    primary: {
      type: Boolean,
      default: false
    },
    // etc...
    detail: {
      type: String,
      default: null,
    },
    elevation: {
      type: String,
      default: '0'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return {
        'primary': this.primary && !this.disabled,
        'disabled': this.disabled,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.subtitle
  font-size 11px

.primary
  background-image linear-gradient(to right, #4476aa, #2364a2)

.disabled
  background-image linear-gradient(to right, #7d8082, #919293)
</style>
